/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgSearch = (props)=>/*#__PURE__*/ React.createElement("svg", {
        width: "1em",
        height: "1em",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M20 6C12.268 6 6 12.268 6 20s6.268 14 14 14c3.416 0 6.546-1.223 8.976-3.256l10.89 10.89a1.25 1.25 0 0 0 1.768-1.768l-10.89-10.89A13.944 13.944 0 0 0 34 20c0-7.732-6.268-14-14-14ZM8.5 20c0-6.351 5.149-11.5 11.5-11.5S31.5 13.649 31.5 20 26.351 31.5 20 31.5 8.5 26.351 8.5 20Z",
        fill: "#212121"
    }));
export default SvgSearch;
